var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sweet-modal',{ref:_vm.modalUid,staticClass:"modal-form",class:_vm.klass,attrs:{"title":_vm.title,"width":_vm.width},on:{"open":_vm.onModalOpen,"close":_vm.onModalClose}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0859e0a0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@triotech/vue-core/src/components/TModal.vue
// module id = 970
// module chunks = 1